import React, { useCallback, useMemo, useContext } from 'react'
import useCruiseSearchFacets from 'hooks/Cruise/useCruiseSearchFacets'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import SearchLocationInput from 'components/Search/SearchForm/SearchLocationInput/SearchLocationInput'
import LocationFloatingPanel from 'components/SearchV2/Components/Mobile/LocationSearchFloatingPanel/LocationFloatingPanel'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import useToggle from 'hooks/useToggle'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

interface Props {
  onChange: (values: App.CruiseGlobalFilters) => void
  drawerMode?: boolean
}

function CruiseDepartureInputFilter({ drawerMode, onChange }: Props) {
  const [facets] = useCruiseSearchFacets({ facetTypes: ['departure_ports'] })
  const [isOpen, toggleModal] = useToggle(false)

  const handlerSearchItem = useCallback((item?: App.SearchItem | undefined) => {
    onChange({ secondarySearchItem: item })
  }, [onChange])

  const mobileSearchItem = useCallback((item?: App.SearchItem | undefined) => {
    handlerSearchItem(item)
    toggleModal()
  }, [toggleModal, handlerSearchItem])

  const departures = useMemo((): Array<App.SearchItem> => {
    return facets
      .filter((facet) => facet.category === 'departure_ports')
      .map((facet) => ({
        searchType: 'destination',
        value: facet.value,
        format: {
          mainText: facet.name,
        },
      }))
  }, [facets])

  const { secondarySearchItem } = useContext(GlobalSearchStateContext)

  return <div>
    <CSSBreakpoint max="mobile">
      <SearchFormField
        label="Departure port"
        placeholder="All departure ports"
        onClick={toggleModal}
        value={secondarySearchItem?.format?.mainText ?? ''}
      />
      <LocationFloatingPanel
        isOpen={isOpen}
        onClose={toggleModal}
        onGoBack={toggleModal}
        onChange={mobileSearchItem}
        overrideSearchItems={departures}
        popularPlaces={departures}
        placeholder="Departure port"
        title="Departure port"
        isSecondaryLocation
      />
    </CSSBreakpoint>

    <CSSBreakpoint min="tablet">
      {drawerMode && <>
        <SearchFormField
          label="Departure port"
          placeholder="All departure ports"
          onClick={toggleModal}
          value={secondarySearchItem?.format?.mainText ?? ''}
        />
        <LocationFloatingPanel
          isOpen={isOpen}
          onClose={toggleModal}
          onGoBack={toggleModal}
          onChange={mobileSearchItem}
          overrideSearchItems={departures}
          popularPlaces={departures}
          placeholder="Departure port"
          title="Departure port"
          isSecondaryLocation
        />
      </>}

      {!drawerMode && <SearchLocationInput
        label="Departure port"
        placeholder="All departure ports"
        onChange={handlerSearchItem}
        isSecondaryLocation
        placeholderItems={departures}
        overrideSearchItems={departures}
        variant="dropdown"
      />}
    </CSSBreakpoint>
  </div>
}

export default CruiseDepartureInputFilter
